const linhas = (category, rows) =>
  rows.map(([key, label, example]) => ({ key: `produto1.${key}`, label, category, example }));

export const MACROS = [
  ...linhas('Descrição', [
    ['descricao', 'Descrição completa', 'Arroz tipo 1 5kg'],
    ['descricao-1', 'Primeira parte da descrição', 'Arroz tipo 1 5kg'],
    ['descricao-2', 'Segunda parte da descrição', ''],
    ['codigo', 'Código interno', '1234'],
    ['ean', 'EAN', '7891234567890'],
    ['unidade', 'Unidade', 'UN'],
    ['id', 'ID do produto', '42'],
  ]),
  ...linhas('Preços', [
    ['precovarejo', 'Varejo formatado', 'R$ 12,50'],
    ['precocusto', 'Custo formatado', 'R$ 8,00'],
    ['precoatacado', 'Atacado formatado', 'R$ 10,00'],
    ['precopromocao', 'Promoção formatada', 'R$ 11,00'],
    ['precovarejonum', 'Varejo numérico', '12,50'],
    ['precocustonum', 'Custo numérico', '8,00'],
    ['precoatacadonum', 'Atacado numérico', '10,00'],
    ['precopromocaonum', 'Promoção numérica', '11,00'],
    ['qtdatacado', 'Quantidade mínima de atacado', '6'],
  ]),
  ...linhas('Fiscal', [
    ['ncm', 'NCM', '10063021'],
    ['cest', 'CEST', ''],
    ['categoria', 'Categoria', 'Mercearia'],
    ['subcategoria', 'Subcategoria', 'Grãos'],
    ['marca', 'Marca', 'Marca X'],
    ['grupotributario', 'Grupo tributário', 'Tributado'],
  ]),
  ...linhas('Estoque', [
    ['ativo', 'Ativo', 'Sim'],
    ['balanca', 'Modo balança', '0'],
    ['estoqueatual', 'Estoque atual', '15,000'],
    ['estoqueminimo', 'Estoque mínimo', '5,000'],
    ['estoqueideal', 'Estoque ideal', '10,000'],
    ['estoquemaximo', 'Estoque máximo', '50,000'],
    ['validade', 'Validade em dias', '30'],
    ['dataimpressao', 'Data de impressão', '01/09/2026'],
    ['horaimpressao', 'Hora de impressão', '14:30'],
  ]),
];

export const MACRO_KEYS = new Set(MACROS.map((x) => x.key));

export const defaultSampleData = () => Object.fromEntries(MACROS.map((x) => [x.key, x.example]));

const RE = /\{([^{}]+)\}/g;

export function findMacros(text) {
  return [...String(text || '').matchAll(RE)].map((x) => x[1]);
}

export function unknownMacros(text, known = MACRO_KEYS) {
  return findMacros(text).filter((k) => !known.has(k));
}

export function renderSample(text, data) {
  return String(text || '').replace(RE, (all, k) => (k in data ? data[k] : all));
}
